export default __webpack_public_path__ + "static/media/Statement_of_deviation_of_Variation_q3.d3370fa7.pdf";